import { TestMeasurement } from '../types';

interface Data {
  [year: string]: TestMeasurement[];
}
const groupByYear = (data: TestMeasurement[]) => {
  const groupedData: Data = {};

  data.forEach((item) => {
    const year = new Date(item.testedAt).getFullYear();

    if (!groupedData[year]) {
      groupedData[year] = [];
    }

    groupedData[year].push(item);
  });

  return Object.entries(groupedData).reverse();
};

export default groupByYear;
